<template>
  <div class="acomodar">
    <!-- -->
    <Inventario/>
  </div>
</template>

<script>
  import Inventario from '@/components/Inventario/Inventario.vue';
export default {
  name: 'CopiasInventario',
  components:{
    Inventario
  },
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style scoped>


</style>